import React from 'react';
import { useFocusEffect } from '@react-navigation/native';

import { LoyaltyOffers, LoyaltyPostPurchaseModal } from '@order/components';
import {
  useLogLoyaltyOnboardingModalEvents,
  useTrackLoyaltyOnboardingModal,
} from '@order/hooks';

import { HomeScreenContent } from './components';

export const HomeScreen = () => {
  const logLoyaltyOnboardingModalEvents = useLogLoyaltyOnboardingModalEvents();
  const trackLoyaltyOnboardingModal = useTrackLoyaltyOnboardingModal();

  // ─── Effects ─────────────────────────────────────────────────────────

  useFocusEffect(trackLoyaltyOnboardingModal);
  useFocusEffect(logLoyaltyOnboardingModalEvents);

  // ─────────────────────────────────────────────────────────────────────

  return (
    <>
      <HomeScreenContent />
      <LoyaltyOffers.Modal />
      <LoyaltyPostPurchaseModal />
    </>
  );
};
